import React from "react";
import { Row } from "react-bootstrap";

import { HookFormInput } from "components/hookForms";

import styles from "../filter.module.scss";

type NumericRangeSectionProps = {
	register: (Ref, RegisterOptions?) => void;
	section: {
		nameInputFrom: string;
		nameInputTo: string;
		normalize: Function;
		normalizeOnBlur: Function;
		title: string;
		addon?: string;
	};
	isInvalid?: boolean;
	onBlur?: Function;
};

const NumericRangeSection = ({
	register,
	section,
	isInvalid,
	onBlur,
}: NumericRangeSectionProps) => {
	const { nameInputFrom, nameInputTo, normalize, normalizeOnBlur, addon } =
		section;

	return (
		<div>
			{section?.title && (
				<div className={styles.ageTitle}>{section?.title}</div>
			)}
			<Row className="mb-1">
				<HookFormInput
					register={register}
					name={nameInputFrom}
					normalizeOnBlur={normalizeOnBlur}
					normalize={normalize}
					isInvalid={isInvalid}
					onBlur={onBlur}
					label="From"
					colInput={9}
					colLabel={3}
					autoComplete="off"
					addon={addon}
				/>
			</Row>
			<Row className="mb-1">
				<HookFormInput
					register={register}
					name={nameInputTo}
					normalizeOnBlur={normalizeOnBlur}
					normalize={normalize}
					isInvalid={isInvalid}
					onBlur={onBlur}
					label="To"
					colInput={9}
					colLabel={3}
					autoComplete="off"
					addon={addon}
				/>
			</Row>
		</div>
	);
};

export default NumericRangeSection;
